import * as React from "react";
import * as ReactDOM from "react-dom";
import {
    Card,
    CardHeader,
    CardTitle,
    CardBody,
    CardActions,
    CardImage,
    CardSubtitle,
    Avatar,
} from "@progress/kendo-react-layout";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Tooltip } from "@progress/kendo-react-tooltip";

const ESSystems = [
    {
        "id": "4721c947-805c-4542-97cf-479688f64e58",
        "name": "Sloan Prod Tenant Restful API Connection",
        "description": "Realtime Data from Sinch Contact Pro (PROD)",
        "readfrequency": "20",
        "status": "true"
    }
];

 export const ExternalSystems = () => {
     const [systems, setSystems] = React.useState(ESSystems);
     const editSystem = (system) => {
         
     };
    return (
        <div
            style={{
                display: "flex",
                justifyContent: "left",
                flexWrap: "wrap",
            }}
        >
            {systems.map((system, index) => {
                return (
                    <div key={index}>
                        <Card
                            style={{
                                width: 300,
                                boxShadow: "0 0 4px 0 rgba(0, 0, 0, .1)",
                                marginTop: "15px",
                                marginRight: '15px'
                            }}
                        >
                            <CardHeader
                                className="k-hbox"
                                style={{
                                    background: "transparent",
                                }}
                            >
                                <div>
                                    <CardTitle
                                        style={{
                                            marginBottom: "4px",
                                        }}
                                    >
                                        {system.name}
                                    </CardTitle>
                                    <CardSubtitle>
                                        <p>{system.description}</p>
                                    </CardSubtitle>
                                </div>
                            </CardHeader>

                            <CardActions
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                }}
                            >
                                <div>
                                    <Tooltip anchorElement="target" position="top">
                                    <button title="Edit Connection Info"
                                        className="k-button k-button-md k-rounded-md k-button-flat k-button-flat-base"
                                        onClick={() => editSystem(system)}
                                    >
                                        <FontAwesomeIcon icon={'fa-solid fa-gear fa-fw'} />
                                      
                                    </button>
                                    <button title="Synch Users" className="k-button k-button-md k-rounded-md k-button-flat k-button-flat-base">
                                        <FontAwesomeIcon icon={'fa-solid fa-users fa-fw'} />
                                    </button>
                                    <button title="Synch Queues" className="k-button k-button-md k-rounded-md k-button-flat k-button-flat-base">
                                        <FontAwesomeIcon icon={'fa-solid fa-layer-group fa-fw'} />
                                        </button>
                                    </Tooltip>
                                </div>

                            </CardActions>
                        </Card>
                    </div>
                )
            })}
        </div>
    )
}